import { notifications } from '@mantine/notifications';
import { useMutation, useQueryClient } from '@tanstack/react-query'

// The booking flow reads the package list through its own cached query, and the client
// is configured with refetchOnWindowFocus off, so nothing else would drop it. Matched by
// key prefix because that query is keyed by its filter params as well.
const invalidatePackages = (queryClient) => queryClient.invalidateQueries({
    queryKey: ['api-v1-studio-get-packages'],
});

export const mutatePackageCreate = () => {

    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationKey: ['package-create'],
        mutationFn: async (formData) => {
            const res = await axios.post(route('studio.v1.api.packages.store'), formData);
            return res;
        },
        onSuccess: async () => {
            await invalidatePackages(queryClient);

            notifications.show({
                color: 'green',
                title: 'Success',
                message: 'Package created',
            })
        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: 'Error',
                message: response?.data?.message || "",
            })
        }
    });

    return mutation;
}
